import { formatIsoDate } from '../vacationOverviewPage.utils';
import { DISPLAY_DATE_META } from '../vacationOverviewPage.definitions';
import type { DisplayDate, Status } from '../../../utils/panorama/panoramaPeopleRows';

const EMPTY = <span className="text-raro-gray-400">—</span>;

interface DateDisplayCellProps {
	displayDates: DisplayDate[];
	status?: Status;
	expiredDays?: number;
}

export function DateDisplayCell({ displayDates, status, expiredDays = 0 }: DateDisplayCellProps) {
	if (displayDates.length === 0) return EMPTY;

	return (
		<div className="space-y-2 text-sm">
			{displayDates.map((date, idx) => {
				const meta = DISPLAY_DATE_META[date.kind];
				const fractionLabel = date.fraction ? ` · ${date.fraction}ª fração` : '';
				const shouldAddFraction = (date.kind === 'request' || date.kind === 'request-approved' || date.kind === 'request-rejected') && date.fraction;
				const label = shouldAddFraction ? `${meta.label}${fractionLabel}` : meta.label;

				if (date.kind === 'acquiring') {
					return (
						<div key={idx}>
							<p className="text-xs font-semibold" style={{ color: meta.color }}>
								{label}
							</p>
							{date.startDate ? (
								<p className="font-medium text-raro-gray-900">{formatIsoDate(date.startDate)}</p>
							) : (
								<p className="font-medium text-raro-gray-900">—</p>
							)}
						</div>
					);
				}

				const isDateOnly = date.endDate === null;
				const dateText = isDateOnly
					? formatIsoDate(date.startDate)
					: `${formatIsoDate(date.startDate).slice(0, 5)} – ${formatIsoDate(date.endDate ?? '')}`;

				return (
					<div key={idx}>
						<p className="text-xs font-semibold" style={{ color: meta.color }}>
							{label}
						</p>
						<p className="font-medium text-raro-gray-900">{dateText}</p>
						{date.kind === 'deadline-passed' && expiredDays > 0 && (
							<p className="text-xs text-raro-gray-500">{expiredDays} dia{expiredDays !== 1 ? 's' : ''} vencido{expiredDays !== 1 ? 's' : ''}</p>
						)}
						{date.kind === 'request-rejected' && (
							<p className="text-xs text-raro-gray-500">aguardando nova data</p>
						)}
					</div>
				);
			})}
		</div>
	);
}
